export default "__VITE_ASSET__D4o6HgtI__"